import { sha256 } from 'hash.js'
import crypto from '../services/crypto'
import S3FileUpload from 'aws-s3'

const s3Config = {
    bucketName: 'public.aitmed.com',
    dirName: 'staffingLogos' /* optional */,
    region: 'us-east-2',
    accessKeyId: 'AKIA3CESR5P4VGVTVYPK',
    secretAccessKey: '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',
    s3Url: 'https://s3.us-east-2.amazonaws.com/public.aitmed.com',
}
const FileUploader = new S3FileUpload(s3Config)

const utils = (function () {

    return {
        generalCallback,
        encryptSecretKeyWithPassword,
        normalizeStringTo32BitArray,
        objectToBase64,
        storeCredentialsInLocalStorage,
        fileUpload,
    }
    /**
     * 
     * @param file 
     * @param fileName 
     * 
     * uploads file to an aws s3 bucket
     */
    function fileUpload({ file, fileName }: { file: any, fileName: any }) {
        return FileUploader.uploadFile(file, fileName)
            .then((data: any) => {
                return data
            })
            .catch((error: Error) => { console.error(error) })
    }

    /**
     * 
     * @param deat the response 
     * @param err an error response
     * 
     * used as a general callback to pass to methods 
     */
    function generalCallback(deat: any, err: any) {
        if (err) {
            console.log(err.getMessage())
            return ''
        } else if (deat) {
            return deat
        }
    }
    /**
     * 
     * @param param0 
     * 
     * helper method to encrypt the secretKey with the user's password
     */
    function encryptSecretKeyWithPassword({ secretKey, password }: any) {
        const passwordSha256 = sha256().update(password).digest()
        const passwordUintArray = new Uint8Array(passwordSha256)
        const encryptedSecretKey = crypto.sKeyEncrypt(passwordUintArray, secretKey)
        return encryptedSecretKey
    }

    /**
     * 
     * @param string 
     * 
     * helper method used to normalize any size string to a 32bit array
     * used to pass in data to encrypt since encrypt/decrypt methods
     * only handle 32bit array data
     */
    function normalizeStringTo32BitArray(string: any) {
        const stringSha256 = sha256().update(string).digest()
        const stringUintArray = new Uint8Array(stringSha256)
        return stringUintArray
    }

    /**
     * 
     * @param obj 
     * 
     * converts object to base64 to be able to decrease the data size of the JSONObject
     */
    function objectToBase64(obj: any) {
        const objJsonString = JSON.stringify(obj)
        const objJsonB64 = Buffer.from(objJsonString).toString("base64")
        return objJsonB64
    }

    /**
     * 
     * @param param0 
     * 
     * helper function to store user credentials in localstorage
     */
    function storeCredentialsInLocalStorage({ secretKey, publicKey, jwt, user }: any) {
        const encodePublicKeyToBase64 = crypto.uint8ArrayToBase64(publicKey)
        const encodeSecretKeyToBase64 = crypto.uint8ArrayToBase64(secretKey)
        localStorage.setItem('user', user)
        localStorage.setItem('publicKey', encodePublicKeyToBase64)
        localStorage.setItem('secretKey', encodeSecretKeyToBase64)
        localStorage.setItem('jwt', jwt)
    }
}())

export default utils